import React, { useState } from "react";

interface Props {
  title: string;
  subTitle: string;
  collapseCharLimit?: number;
}

const DescriptionTile = ({ title, subTitle, collapseCharLimit = 300 }: Props) => {
  const [expanded, setExpanded] = useState(false);
  const isLong = subTitle.length > collapseCharLimit;
  const preview = isLong ? subTitle.slice(0, collapseCharLimit).trimEnd() + "…" : subTitle;

  return (
    <div className="px-4">
      <div className="bg-white shadow-black/50 shadow-lg rounded-lg p-4">
        <div className="flex items-start justify-between">
          <h4 className="text-lg font-semibold text-gray-900">{title}</h4>
        </div>

        <div className="mt-3 text-sm text-gray-700 whitespace-pre-line" aria-live="polite">
          {expanded || !isLong ? subTitle : preview}
        </div>

        {isLong && (
          <div className="mt-4 flex justify-center">
            <button
              onClick={() => setExpanded((s) => !s)}
              aria-expanded={expanded}
              className="text-sm text-blue-600 hover:underline focus:outline-none"
            >
              {expanded ? "See less" : "See more"}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default DescriptionTile;
